import React from "react";
import { Input, ConfigProvider } from "antd";

const InputField = ({
  hoverBorder = false,
  size = "large",
  type = "text",
  placeholder = "",
  value,
  disabled = false,
  onChange,
  onBlur,
  onFocus,
  style = {},
  className = "",
  ...rest
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            borderRadius: 0, // flat style
            // colorBgContainer: "rgba(0,0,0,0.04)", // soft background
            borderColor: "transparent",
            colorText: "#333",
            paddingBlock: 10,
            paddingInline: 12,
            colorBorder: "transparent",
          },
        },
      }}
    >
      <Input
        type={type}
        size={size}
        placeholder={placeholder}
        value={value}
        maxLength={150}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        style={{
          width: "100%",
          // backgroundColor: "rgba(0,0,0,0.04)",
          // border: "none", // explicitly remove border
          borderRadius: 8,
          ...style,
        }}
        className={`${hoverBorder ? "custom-input-hover" : ""} ${className}`}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default InputField;
